import { render } from "./FormCheckboxButtons.vue?vue&type=template&id=5fc7afc0"
import script from "./FormCheckboxButtons.vue?vue&type=script&lang=js"
export * from "./FormCheckboxButtons.vue?vue&type=script&lang=js"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__